import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { utils } from '@myplay/all';
import { SwitchClubModal, DotLoader } from '@myplay/ui';
import ReactTooltip from 'react-tooltip';

import { NavigationBar, ImagePickerModal } from '..';
import { capitalize } from '../../utils/stringManipulations';
import I18N from '../../I18N';
import './SideBar.scss';

const SideBar = ({ ClubsStore, MetaStore })=> {
  const { currentClub: { club }, updateClubLogo, clubs } = ClubsStore;
  const { isLoading } = MetaStore;
  const [ newImage, setNewImage ] = useState(null);
  const [ shouldDisplayClubsModal, setShouldDisplayClubsModal ] = useState(false);

  const handleNewImage = event => {
    const reader = new FileReader();
    reader.onloadend = onLoadEvent => {
      setNewImage(onLoadEvent.target.result);
    };

    utils.ImageTools.resize(
      event.target.files[0],
      {
        width: 540,
        height: 360
      },
      compressed => {
        reader.readAsDataURL(compressed);
      }
    );
  };

  const discardNewImage = ()=> {
    setNewImage(null);
  };

  const handleSave = async croppedImage => {  
    await updateClubLogo(croppedImage);
    setNewImage(null);
  };

  const handleClubSelect = club => {
    ClubsStore.switchClub(club._id);
  };
  return(
    <div className="side-bar" data-testid="side-bar">
        <div className="side-bar__header">
          {!isLoading ?
            <Fragment>
              <label className="side-bar__header__logo" data-for="logo" data-tip={capitalize(I18N.t("UPDATE_CLUB_LOGO"))}>
                {
                  club && club.logo &&
                  <img 
                    className="side-bar__header__logo" 
                    src={club ? club.logo : ""} 
                    alt='' 
                    data-for="logo"
                  />
                }
                <input type="file" onChange={event => handleNewImage(event)} value="" data-testid="logo-input"/>
              </label>
              <ReactTooltip id="logo" />
              <p className="side-bar__header__name">{club ? club.name : ""}</p>
              {clubs.length > 1 &&
                <button className="side-bar__header__switch-club" onClick={()=> setShouldDisplayClubsModal(true)}>
                  <span>{capitalize(I18N.t("SWITCH_CLUB"))}</span>  
                </button>
              }
            </Fragment> :
            <DotLoader />
          }
        </div>
      <ImagePickerModal img={newImage} onCancel={discardNewImage} onSave={handleSave}/>
      <NavigationBar />
      <SwitchClubModal 
        isVisible={shouldDisplayClubsModal} 
        clubs={clubs} 
        onClose={()=> setShouldDisplayClubsModal(false)}
        onSelect={handleClubSelect}
      />
    </div>
  );
};

SideBar.propTypes = {
  ClubsStore: PropTypes.object
};

SideBar.defaultProps = {
  ClubsStore: {}
};

export default inject("ClubsStore", "MetaStore")(observer(SideBar));